import { useEffect } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Card } from '@iwoca/orion';

import { ApprovalHeader } from '../ApprovalHeader';
import { TOfferSetType } from '../getOfferSetType';
import { NewLoanSummary } from '../NewLoanSummary/NewLoanSummary';
import { OfferTimeoutAlertBox } from '../OfferTimeoutAlertBox';
import { PageContainer } from '../PageContainer';
import { LoanExtensionRadioGroup } from './LoanExtensionRadioGroup';

export const RepaymentReductionWithChoice = ({
    timeoutDate,
    offerSetType,
    formalOffers,
    selectedOffer,
    setSelectedOffer,
    outstandingBalance
}: {
    timeoutDate: string;
    offerSetType: TOfferSetType;
    formalOffers: TFormalOffer[];
    selectedOffer: TFormalOffer | null;
    setSelectedOffer: (offer: TFormalOffer | null) => void;
    outstandingBalance: number;
}) => {
    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: 'repayment_reduction_with_choice'
        });
    }, []);

    return (
        <PageContainer data-testid="decision-approved">
            <Card className="space-y-xl min-l:p-xl">
                <OfferTimeoutAlertBox timeoutDate={timeoutDate} />
                <ApprovalHeader offerSetType={offerSetType} />
                <LoanExtensionRadioGroup
                    offers={formalOffers}
                    selectedOffer={selectedOffer}
                    setSelectedOffer={setSelectedOffer}
                    outstandingBalance={outstandingBalance}
                />
            </Card>
            <NewLoanSummary
                selectedAmount={0}
                selectedOffer={selectedOffer}
                outstandingBalance={outstandingBalance}
            />
        </PageContainer>
    );
};
